// extracted by mini-css-extract-plugin
export default {"loader":"loopAnimation_loader__vYFnq","spin":"loopAnimation_spin__XvUJ6"};